import React from 'react';

import './EstimatedTradeCostComparisonWidgetContentLeftHandPanel.scss';
import { usePortfolioSelectedSymbol } from 'portfolio/store/hooks';
import { EstimatedTradeCostWidgetRequestQty } from 'widgets/estimatedTradeCost/widget/components/EstimatedTradeCostWidgetRequestQty';
import { useEstimatedTradeCostComparisonWidgetConfigSlice } from 'widgets/estimatedTradeCost/widget-comparison/store/configslice';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';
import classNames from 'classnames';
import { useSelectLocked } from 'layoutRenderer/store/selectors';
import { EstimatedTradeCostComparisonData } from 'widgets/estimatedTradeCost/widget-comparison/estimatedTradeCostComparisonData';

export function EstimatedTradeCostComparisonWidgetContentLeftHandPanel({
    data,
    editedQty,
    onQtyChanged,
}: {
    data: EstimatedTradeCostComparisonData | undefined;
    editedQty: number | undefined;
    onQtyChanged: (qty: number) => void;
}) {
    const {
        config: { collapseLeftHandPanel },
        dispatchConfigChanged,
    } = useEstimatedTradeCostComparisonWidgetConfigSlice();

    const layoutLocked = useSelectLocked();

    const symbol = usePortfolioSelectedSymbol();

    const onClickCollapse = () => {
        dispatchConfigChanged({ collapseLeftHandPanel: true });
    };
    const onClickReveal = () => {
        dispatchConfigChanged({ collapseLeftHandPanel: false });
    };

    const cssClasses = classNames(
        'EstimatedTradeCostComparisonWidgetContentLeftHandPanel',
        collapseLeftHandPanel ? 'collapsed' : 'panel-shown',
        layoutLocked && 'locked'
    );

    const request = data?.firstRequest;

    return (
        <>
            <div className={cssClasses}>
                {collapseLeftHandPanel && (
                    <div className="show-panel arrow-icon">
                        <ToolbarIcon
                            name={'angle right'}
                            tooltip={'Show Panel'}
                            onClick={onClickReveal}
                        />
                    </div>
                )}
                {!collapseLeftHandPanel && (
                    <>
                        <div className="symbol">{symbol}</div>
                        <div className="qty">
                            {
                                <EstimatedTradeCostWidgetRequestQty
                                    editedQty={editedQty}
                                    request={request}
                                    onQtyChanged={onQtyChanged}
                                    suppressLabel={true}
                                />
                            }
                        </div>
                        {!layoutLocked && (
                            <div className="hide-panel arrow-icon">
                                <ToolbarIcon
                                    name={'angle left'}
                                    tooltip={'Hide Panel'}
                                    onClick={onClickCollapse}
                                />
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
}
